import { render, staticRenderFns } from "./course-certificate.vue?vue&type=template&id=66469c96&"
import script from "./course-certificate.vue?vue&type=script&lang=js&"
export * from "./course-certificate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports